(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-return"]) return;
  try {
    
  const gobackEl = document.querySelector("#goback");

  if( gobackEl ) {
    gobackEl.addEventListener("click", function(evt){
      evt.preventDefault();

      if( document.referrer.includes('/collections') || document.referrer.includes('/search') ) {
        history.back();
      }
      else {
        window.location.href = '/collections/all-sets';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const gobackEl = document.querySelector("#goback");

  if( gobackEl ) {
    gobackEl.addEventListener("click", function(evt){
      evt.preventDefault();
      var defaultURL = '/collections/all-sets';

      if( document.referrer ) {
        if( !document.referrer.includes(':') || (document.referrer.includes('ccnd-development') || document.referrer.includes('citiesuntold.dwarvenforge.com')) ) {
          history.back();
        }
        else {
          window.location.href = defaultURL;
        }
      }
      else {
        window.location.href = defaultURL;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-menu"] && !window.DesignMode) return;
  try {
    
function offset(elt) {
  if( elt ) {
    var rect = elt.getBoundingClientRect(), bodyElt = document.body;
    return {
      top: rect.top + bodyElt .scrollTop,
      left: rect.left + bodyElt .scrollLeft
    }
  }
}
 
window.addEventListener("load", function(){
  window.scrollTo(0, 0);

  if(document.querySelector("aside")){
    const sidebar = document.querySelector("aside");
    const footer = document.querySelector("#shopify-section-footer-promotions")? document.querySelector("#shopify-section-footer-promotions") : document.querySelector("#shopify-section-footer");
    const top = offset(sidebar).top - 50;
    const footTop = offset(footer).top;
    const maxY = footTop - sidebar.offsetHeight - 50;

    window.addEventListener("scroll", function(){
      let y = document.scrollingElement.scrollTop;

      if (y > top) {
        if (y < maxY) {
          sidebar.classList.add("fixed")
        } else {
          sidebar.classList.remove("fixed")
        }
      } else {
        sidebar.classList.remove("fixed")
      }
    })
  }
});

  } catch(e) { console.error(e); }
})();

})();
